import React from 'react';
import { BsCheckCircle, BsXCircle } from 'react-icons/bs';

interface SuccessAlertProps {
    success: boolean;
    message: string;
}

const SuccessAlert: React.FC<SuccessAlertProps> = ({ success, message }) => {
  return (
    <div className={`flex items-center space-x-2 rounded-lg bg-${success ? 'green' : 'red'}-50 p-3 text-${success ? 'green' : 'red'}-800`}>
      <div className="flex-shrink-0">
        {
            success ? <BsCheckCircle className="h-5 w-5" /> : <BsXCircle className="h-5 w-5" />
        }
      </div>
      <span className="text-sm font-medium">{message}</span>
    </div>
  );
};

export default SuccessAlert;
